import { Activity } from 'lucide-react'

import { formatImpact, type ImpactLike } from './impact'

export interface ImpactCalloutProps {
  impact?: ImpactLike
  /** Callout label; defaults to "Impact". */
  label?: string
}

/**
 * Prominent operator-facing callout for an insight's impact ("how much").
 * Visual sibling of {@link TimeframeCallout} — a tinted, bordered banner with
 * an icon and a large value — so timeframe and impact read at a glance side by
 * side. Renders nothing when there is no impact to show.
 */
export function ImpactCallout({ impact, label = 'Impact' }: ImpactCalloutProps) {
  const text = formatImpact(impact)
  if (!text) return null
  return (
    <div className="flex items-center gap-3 rounded-lg border border-brand/40 bg-brand/10 px-4 py-3">
      <Activity aria-hidden className="size-6 shrink-0 text-brand" />
      <div className="min-w-0">
        <div className="text-11 font-semibold uppercase tracking-wide text-brand">{label}</div>
        <div className="text-lg font-semibold leading-tight tabular-nums text-ink">{text}</div>
      </div>
    </div>
  )
}
